import { useState, useEffect } from 'react';
import { saveAs } from 'file-saver';

import useSelector from 'shared/hooks/useSelector';

import { appApi } from 'store/app/api';

import LoadingButton from 'shared/components/LoadingButton';

const DownloadRepairInstructionsButton = () => {
  const instructions = useSelector((state) => state.app.repairInstruction);

  const [downloadInstruction] = appApi.useLazyDownloadRepairInstructionQuery();
  const [showedLoader, showLoader] = useState(false);

  const handleClickButton = async () => {
    if (instructions) {
      try {
        showLoader(true);

        const blob = await downloadInstruction(instructions, true).unwrap();

        saveAs(blob, 'Muutostyöohje.pdf');
      } catch (err) {
        console.error(err);
      } finally {
        showLoader(false);
      }
    }
  };

  useEffect(() => {}, []);

  if (!instructions) return null;

  return (
    <LoadingButton
      color="secondary"
      disabled={showedLoader}
      loading={showedLoader}
      onClick={handleClickButton}
      sx={{ fontWeight: 600 }}
    >
      MUUTOSTYÖOHJE
    </LoadingButton>
  );
};

export default DownloadRepairInstructionsButton;
